import { Component, Inject, Injector, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { GridComponent } from '@progress/kendo-angular-grid';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';
import { AppComponentBase } from '../app-component-base';
import { CommonDataModel } from '../common-data-model';
import { CommonConstants } from 'src/app-core/constants/common-constants';

const hasClass = (el, className) => new RegExp(className).test(el.className);
const isChildOf = (el, className) => {
    while (el && el.parentElement) {
        if (hasClass(el.parentElement, className)) {
            return true;
        }
        el = el.parentElement;
    }
    return false;
};

@Component({
    selector: 'app-status-carrier-build-intransit',
    templateUrl: './status-carrier-build-intransit.component.html',
    styleUrls: ['./status-carrier-build-intransit.component.scss']
})
export class StatusCarrierBuildIntransitComponent extends AppComponentBase implements OnInit {

    @ViewChild('grid', { static: true }) public grid: GridComponent;
    @ViewChild('statusChangeForm', { static: true }) statusChangeForm: NgForm;

    commonDataModel = new CommonDataModel();
    statusChangeFormData = this.commonDataModel.ordersCarrierStatusChangeModel;
    isFormLoading = false;
    tenantId = this.commonService.getTenentId();
    popupData: any;
    dimsGetResponseCopy: any;
    orderId: string;
    carrierItemList: any;
    defaultCarrierItem = { carrierName: 'Select', carrierId: null };
    gridItems: any = {
        data: [],
        total: 0
    };
    editedRowIndex: number;
    minDate = moment().subtract(3, 'weeks').format();

    constructor(
        injector: Injector,
        private toastr: ToastrService,
        private dialogRef: MatDialogRef<StatusCarrierBuildIntransitComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private commonService: CommonService,
        private renderer: Renderer2,
        private activatedRoute: ActivatedRoute,
    ) {
        super(injector);
        this.popupData = this.data;
        this.renderer.listen(
            'document',
            'click',
            ({ target }) => {
                if (!isChildOf(target, 'finalDimsGrid')) {
                    if (this.statusChangeForm.valid) {
                        this.grid.closeRow(this.editedRowIndex);
                        this.editedRowIndex = null;
                    }
                }
            });
    }

    ngOnInit() {
        this.onLoadItems();
    }

    onLoadItems() {
        if (this.activatedRoute.snapshot.queryParams.jobId) {
            this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
        } else {
            this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
        }
        this.statusChangeFormData.date = moment().format();
        this.statusChangeFormData.time = moment().format();
        this.statusChangeFormData.statusId = this.popupData.eventData.id;
        this.statusChangeFormData.statusName = this.popupData.eventData.name;
        this.statusChangeFormData.orderId = this.orderId;
        this.getCarriersList();
        this.getFinalDims();
    }

    getCarriersList() {
        const queryString = `CarrierId=${this.statusChangeFormData.carrierId === null ? 0 : this.statusChangeFormData.carrierId}`;
        this.commonService.getCarriersList(queryString).subscribe((response: any) => {
            if (response.isSuccess) {
                this.carrierItemList = response.data;
            }
        });
    }

    getFinalDims(): void {
        this.isFormLoading = true;
        const query = `?OrderId=${this.orderId}`;
        this.commonService.getFinalDimsRouting(query)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    response.data.shippingCost = response.data.shippingCost ? response.data.shippingCost.toFixed(2) : 0;
                    this.dimsGetResponseCopy = _.cloneDeep(response.data);
                    this.statusChangeFormData = Object.assign(this.statusChangeFormData, response.data);
                    this.statusChangeFormData.items = response.data.getFinalBol || [];
                    if (this.statusChangeFormData.items) {
                        this.gridItems.data = this.statusChangeFormData.items;
                    }
                    this.statusChangeFormData.carrierName = this.carrierItemList.find(cr => cr.id === this.statusChangeFormData.carrierId).carrierName;
                    this.statusChangeFormData.carrierUrl = this.carrierItemList.find(cr => cr.id === this.statusChangeFormData.carrierId).carrierUrl;
                    this.statusChangeFormData.carrierPhone = this.carrierItemList.find(cr => cr.id === this.statusChangeFormData.carrierId).phone;
                } else {
                    this.toastr.error(
                        response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                }
            });
    }

    getNewBOL(): any {
        const itemModel = Object.assign({}, this.commonDataModel.ordersFinalDimsBOLModel);
        return itemModel;
    }

    onAddBOL() {
        this.gridItems.data.splice(0, 0, this.getNewBOL());
        this.gridItems.total = this.gridItems.data.length;
    }

    onRemoveBOL(index: any) {
        this.gridItems.data.splice(index, 1);
    }

    onCellClickHandler({ sender, rowIndex }, grid: any) {
        grid.closeRow(this.editedRowIndex);
        this.editedRowIndex = rowIndex;
        sender.editRow(rowIndex);
    }

    onCarrierChange(event: any) {
        this.statusChangeFormData.carrierName = event.carrierName;
        this.statusChangeFormData.carrierUrl = event.carrierUrl ? event.carrierUrl : null;
    }

    onSubmit(): void {
        this.statusChangeFormData.serviceDate = moment(this.statusChangeFormData.date).format('YYYY-MM-DD');
        this.statusChangeFormData.serviceTime = moment(this.statusChangeFormData.time).format('HH:mm:ss');
        this.statusChangeFormData.pro = this.statusChangeFormData.trackingNumber;
        if (!this.statusChangeFormData.carrierId) {
            this.statusChangeFormData.carrierId = 0;
        }
        this.isFormLoading = true;
        this.commonService.changeCarrierBuildInTransitStatus(this.statusChangeFormData)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                    const sendingData = { confirmResult: true, repData: response.data };
                    this.dialogRef.close(sendingData);
                } else {
                    this.toastr.error(
                        response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                }
            });
    }

    onClose(confirm: boolean): void {
        this.dialogRef.close(confirm);
    }

}
